import React, { Component } from 'react'

import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import API from 'api.js';
import { store } from 'store/index';
import { setAlert } from 'action/index';
import { getCountryForTimezone } from 'countries-and-timezones';
import PackagesTabs from 'components/Packages/Tabs';
import Plans from 'page/Plans';

 class FreeMockTest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      plans: []
    }
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
    };

    return (
      <React.Fragment>
        <Helmet htmlAttributes>
          <title>
            Free Pte Mock Test With Score Card & Free PTE Practice Test{" "}
          </title>
          <meta name="twitter:title" content="Language Academy" />
          <meta property="og:title" content="Language Academy" />
          <meta
            name="description"
            content="Ace the Pte exam like a pro with Free Pte Mock Test With Score Card and detailed Feedback and Analysis to get your desired scores based on the Latest PTE Academic pattern!"
          />
        </Helmet>
        <div className="homePage">
          <Header />
        </div>
        <div className="innerPage">
          <section className="whiteMenuOuter"></section>
        </div>
        <section
          id="parallax"
          className="la-free-mt-app-first-section slider-area slider-bg2 second-slider-bg d-flex fix"
        >
          <div className="slider-shape" data-depth="0.10">
            <img
              src="https://www.languageacademy.com.au/images/header-sape.png"
              alt="shape"
            />
          </div>
          <div className="slider-shape" data-depth="0.50"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="slider-content second-slider-content left-center">
                  <h1 data-animation="fadeInUp" data-delay=".4s">
                    Upgrade your PTE Preparation with Free PTE Scored Mock Test
                    With Feedback and Analysis
                  </h1>
                  <p data-animation="fadeInUp" data-delay=".6s">
                    With regular practice with our PTE Tutorials Mock Test, you
                    are easily able to achieve the desired PTE scores.
                  </p>
                  <div className="slider-btn mt-30 mb-30">
                    <a
                      href="/auth/login"
                      className="btn ss-btn"
                      data-animation="fadeInUp"
                      data-delay=".8s"
                    >
                      Take a Free PTE Mock Test
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <img
                  src="/images/la-header-object-var3.png"
                  alt="Free Mock Test"
                  className="s-img free-mock-test-banner-img"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="la-free-mt-app-second-section la-free-mt-app-features-section py-50">
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40 mb-45">
                  <h2>Features that Will Help to Ace the PTE Exam!</h2>
                  <p>
                    While preparing for the PTE exam, there are plenty of minute
                    mistakes that might not come to your attention, which could
                    result in low PTE scores. AI-Powered Portal for PTE Mock
                    Test Online has features that save your time and helps you
                    in improving your exam preparation.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center text-center">
              <div className="col-md-4 la-free-mt-app-features-innerr-col1 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <img src="images/rtte-icon.svg" />
                  <h2>Real-time Test Environment</h2>
                  <p>
                    Preparing with our best PTE mock test helps you to gain real
                    test experience beforehand.{" "}
                  </p>
                </div>
              </div>
              <div className="col-md-4  la-free-mt-app-features-innerr-col2 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <img src="images/da-icon.svg" />
                  <h2>Detailed Analytics</h2>
                  <p>
                    After taking the PTE online mock test, the portal provides
                    detailed insights into what went wrong and how you can
                    improve further.
                  </p>
                </div>
              </div>
              <div className="col-md-4 la-free-mt-app-features-innerr-col3 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <img src="images/asa-icon.svg" />
                  <h2>Accurate Scoring Algorithms</h2>
                  <p>
                    The AI-Powered algorithm provides the scorecard within
                    seconds along with the mistakes and corrections.{" "}
                  </p>
                </div>
              </div>
              <div className="col-md-4  la-free-mt-app-features-innerr-col4 la-free-mt-app-features-innerr-col offset-md-2">
                <div className="la-inner-col">
                  <img src="images/ua-icon.svg" />
                  <h2>Unlimited Access</h2>
                  <p>
                    The more you practice, the more chances to score better. You
                    can take our PTE Mock Test anytime within the course
                    duration.{" "}
                  </p>
                </div>
              </div>
              <div className="col-md-4 la-free-mt-app-features-innerr-col5 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <img src="images/vq-icon.svg" />
                  <h2>Verified Questions</h2>
                  <p>
                    Our PTE free complete mock test consists of questions
                    similar to what is asked in the real exam and even in the
                    past exams.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="la-importance-of-mock-tests-section py-50 text-white"
          id="la-importance-of-mock-tests-section"
        >
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div pl-40 pr-40 mb-45">
                  <h2 className="text-center text-white">
                    Importance of Free PTE Mock Tests for Scoring better
                  </h2>
                  <p className="text-center">
                    PTE is an online test to check the English proficiency
                    skills of students appearing in the exam to study in
                    Australia. Free PTE mock tests with score cards are like
                    practice tests conducted at certain intervals before the
                    official examination. They are designed according to the
                    syllabus and the latest exam patterns.
                  </p>
                  <h4>Free mock tests are helpful in different ways:</h4>

                  <ul className="impo-list">
                    <li className="mb-4">
                      <i className="fa fa-check-circle"></i> &nbsp;
                      <b>Gain a Better Perspective:</b>
                      <p>
                        Practising mock tests provides a better perspective on
                        the question type to be asked in the exams.
                      </p>
                    </li>
                    <li className="mb-4">
                      <i className="fa fa-check-circle"></i> &nbsp;
                      <b>Clears Doubts:</b>
                      <p>
                        By giving mock tests, students clear their doubts before
                        their final examination.
                      </p>
                    </li>
                    <li className="mb-4">
                      <i className="fa fa-check-circle"></i> &nbsp;
                      <b>Help improve Time Management:</b>
                      <p>
                        Mock tests enable students to calculate how much time it
                        takes to solve a question. It helps students to manage
                        their time efficiently at the time of final exams.
                      </p>
                    </li>
                    <li className="mb-4">
                      <span>
                        <h6>
                          Similarly, a free PTE mock test with scorecard
                          provides benefits such as:
                        </h6>
                      </span>
                    </li>
                    <li className="mb-4">
                      <i className="fa fa-check-circle"></i> &nbsp;
                      <b>Practice with Sample Questions:</b>
                      <p>
                        Students practice sample questions to test their
                        knowledge before appearing for the official examination.
                      </p>
                    </li>
                    <li>
                      <i className="fa fa-check-circle"></i> &nbsp;
                      <b>Create a Study Plan:</b>
                      <p>
                        Giving PTE mock tests provides a student with the
                        syllabus, study notes, section wise tests. It helps a
                        student to prepare for the exam efficiently.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="la-free-mt-app-exam-pattern-section py-50"
          id="la-free-mt-app-exam-pattern-section"
        >
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40 mb-45">
                  <h2>Know about the PTE Exam Pattern</h2>
                  <p>
                    The PTE exam is divided into four sections - Speaking,
                    Writing, Reading, and Listening. Each section consists of a
                    variety of questions. Keeping in mind the pattern of
                    questions in the real exam, we have curated a full PTE
                    Online Mock Test and even separate sectional practice sets
                    such as PTE Reading Mock Test, PTE Listening Mock Test, etc.
                    For skyrocketing your overall PTE score, it is important to
                    understand and practice each section.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="row exam-pattern-border-top exam-pattern-box-second-row">
              <div className="col-md-6">
                <div className="la-exam-pattern-inner-col">
                  <div className="img-div">
                    <img
                      src="images/speaking-2x.png"
                      className="la-rotate1 exam-pattern-box-img"
                      alt="Speaking"
                    />
                  </div>
                  <div className="la-exam-pattern-content">
                    <h2>Speaking </h2>
                    <p>
                      Make sure to have a good quality microphone with clear
                      sound as the speaking section tests your speaking fluency
                      with proper diction and pronunciation. It includes Read
                      Aloud, Repeat Sentence, Describe Image, Re-tell lecture
                      and Answer Short Questions.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="la-exam-pattern-inner-col">
                  <div className="img-div">
                    <img
                      src="images/writing-2x.png"
                      className="la-rotate2 exam-pattern-box-img"
                      alt="Writing"
                    />
                  </div>
                  <div className="la-exam-pattern-content">
                    <h2>Writing </h2>
                    <p>
                      The Writing section of the PTE exam asks you to summarize
                      the texts and write an essay. Be precise, maintain good
                      writing speed, avoid typos, and do not forget to include
                      the key points. To make it easy and quick, you can use the
                      text editing functions like cut, copy and paste.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row exam-pattern-border-top exam-pattern-box-second-row">
              <div className="col-md-6">
                <div className="la-exam-pattern-inner-col">
                  <div className="img-div">
                    <img
                      src="images/read-2x.png"
                      className="la-rotate3 exam-pattern-box-img"
                      alt="Reading"
                    />
                  </div>
                  <div className="la-exam-pattern-content">
                    <h2>Reading</h2>
                    <p>
                      This section tests your English reading comprehension
                      skills. It includes questions like filling in the blanks,
                      reordering paragraphs, multiple choice answers and others.
                      For improving and practising this particular section, you
                      can take our PTE Reading Mock Test.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="la-exam-pattern-inner-col">
                  <div className="img-div">
                    <img
                      src="images/listening-2x.png"
                      className="la-rotate4 exam-pattern-box-img"
                      alt="Listening"
                    />
                  </div>
                  <div className="la-exam-pattern-content">
                    <h2>Listening</h2>
                    <p>
                      By the name you know, this section assesses your hearing
                      and understanding skills. It includes audio clips of
                      dialogues or monologues, hearing which you need to answer
                      the questions accordingly. Your command on vocab, grammar,
                      spelling could greatly help in acing this section.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="la-free-mt-app-second-section la-free-mt-app-features-section py-50 bg-white">
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40 mb-45">
                  <h2>How Language Academy PTE Scoring Process Works</h2>
                  <p>
                    Achieve a 79 plus score by giving PTE mock tests on the
                    Language Academy PTE portal, with the help of PTE scoring
                    processes. The step-by-step processes that Language Academy
                    follows in PTE scoring are:
                  </p>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-4 la-free-mt-app-features-innerr-col1 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col px-md-3">
                  <svg
                    width="77"
                    height="78"
                    viewBox="0 0 77 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67 0H10C4.47715 0 0 4.47715 0 10V68C0 73.5229 4.47715 78 10 78H67C72.5229 78 77 73.5229 77 68V10C77 4.47715 72.5229 0 67 0Z"
                      fill="#FDEBEC"
                    />
                    <path
                      d="M67 0.5H10C4.75329 0.5 0.5 4.75329 0.5 10V68C0.5 73.2467 4.75329 77.5 10 77.5H67C72.2467 77.5 76.5 73.2467 76.5 68V10C76.5 4.75329 72.2467 0.5 67 0.5Z"
                      stroke="#FDEBEC"
                    />
                    <path
                      d="M56.9984 44.4558C56.828 44.7322 56.5851 44.7989 56.2661 44.7807C54.6204 44.6898 52.9732 44.6209 51.3267 44.5421C50.8123 44.5171 50.6969 44.3967 50.7082 43.8755C50.7354 42.5741 50.5785 41.2977 50.2172 40.0463C50.0603 39.5039 50.1478 39.3501 50.6675 39.1858C52.237 38.6903 53.8081 38.1964 55.3791 37.7041C55.9056 37.5389 56.0587 37.6336 56.2163 38.1646C56.6085 39.4895 56.8529 40.8402 56.9487 42.2181C56.9554 42.3112 56.9818 42.4037 56.9999 42.4961V44.4558H56.9984Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M34.3794 46.8086C34.2504 46.4594 34.1591 46.0912 33.9879 45.7647C32.8227 43.543 31.64 41.3303 30.4634 39.1138C30.4016 38.9964 30.3028 38.8775 30.299 38.7562C30.2945 38.6032 30.3239 38.401 30.422 38.3063C30.5185 38.2124 30.7206 38.1919 30.8722 38.2025C30.9929 38.2108 31.1098 38.3101 31.2229 38.3775C33.4396 39.6895 35.6533 41.0083 37.8767 42.309C38.103 42.4415 38.385 42.5249 38.646 42.54C40.785 42.6605 42.479 44.2611 42.6788 46.376C42.8757 48.4615 41.5045 50.3734 39.4493 50.8787C36.8615 51.5158 34.3598 49.5659 34.2791 46.8487C34.3122 46.8351 34.3462 46.8222 34.3794 46.8086V46.8086Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M37.2062 30.7107C37.2205 31.1645 37.0878 31.2721 36.639 31.3857C35.7324 31.6152 34.8281 31.8569 33.9329 32.1273C33.5791 32.2341 33.2533 32.4318 32.9139 32.5848C32.5051 32.7689 32.3188 32.7174 32.1137 32.3326C31.3089 30.8206 30.5087 29.3056 29.713 27.789C29.5131 27.408 29.5938 27.2035 29.983 27.002C31.8482 26.0354 33.8227 25.4135 35.8946 25.0953C36.2762 25.037 36.4618 25.193 36.5251 25.6498C36.682 26.7861 36.8298 27.9246 36.9822 29.0616C37.0591 29.6366 37.1383 30.2108 37.2062 30.71V30.7107Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M40.2382 25.0006C42.1931 25.2142 43.964 25.6392 45.655 26.374C45.9084 26.4846 46.1671 26.5846 46.4175 26.702C46.778 26.8709 46.8519 27.0853 46.6717 27.4686C46.3277 28.2003 45.9763 28.9283 45.6263 29.657C45.2402 30.4623 44.8555 31.2675 44.4656 32.0705C44.2574 32.4992 44.0915 32.5697 43.6601 32.3735C42.4345 31.8167 41.1583 31.4516 39.8196 31.3031C39.4085 31.2577 39.2637 31.0766 39.3014 30.6721C39.4636 28.9397 39.6325 27.2072 39.8045 25.4756C39.8384 25.1332 40.0262 24.9893 40.2374 25.0006H40.2382Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M49.3039 37.4708C49.1644 37.3283 49.0068 37.1927 48.8793 37.0329C48.3257 36.336 47.797 35.6179 47.2261 34.9361C46.9493 34.6058 46.5978 34.34 46.2825 34.0423C45.9725 33.7506 45.9522 33.5673 46.2214 33.2332C47.2947 31.8993 48.3717 30.5691 49.451 29.2404C49.7195 28.9094 49.9526 28.898 50.2792 29.173C51.8683 30.51 53.2093 32.0629 54.2999 33.8339C54.5405 34.2241 54.499 34.4248 54.0978 34.6672C52.6452 35.5429 51.1903 36.4148 49.7339 37.2844C49.623 37.3503 49.4955 37.3889 49.3039 37.4708V37.4708Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M27.4337 37.8919C27.249 37.8147 27.123 37.7738 27.0084 37.7117C25.5293 36.9034 24.0503 36.0936 22.5743 35.28C22.1617 35.0528 22.121 34.8445 22.3601 34.4195C23.3715 32.6265 24.6386 31.0403 26.1606 29.6578C26.5091 29.3419 26.7074 29.3351 27.0129 29.682C28.1457 30.9683 29.2748 32.2583 30.4009 33.5506C30.6573 33.8453 30.6535 34.0748 30.3669 34.3377C29.3555 35.2687 28.51 36.3292 27.8214 37.52C27.7339 37.6715 27.5605 37.7723 27.4337 37.8904V37.8919Z"
                      fill="#FF3D45"
                    />
                    <path
                      d="M23.149 44.6656C22.3314 44.7027 21.5131 44.7376 20.6955 44.7777C20.1803 44.8035 20.0242 44.6618 20.0084 44.1384C19.9548 42.3264 20.1585 40.5432 20.5997 38.7873C20.7151 38.3275 20.8954 38.2237 21.3652 38.3502C22.9906 38.7888 24.6152 39.2297 26.239 39.6736C26.6757 39.7933 26.7806 39.9736 26.6704 40.4235C26.3899 41.5689 26.2601 42.7286 26.2896 43.9081C26.3016 44.3838 26.1742 44.5156 25.7103 44.5399C24.8565 44.5853 24.0027 44.627 23.149 44.6701C23.149 44.6686 23.149 44.6671 23.149 44.6656V44.6656Z"
                      fill="#FF3D45"
                    />
                  </svg>
                  <h2>Automated Scoring</h2>
                  <p>
                    The Language Academy PTE portal is designed with an
                    automated scoring process, the same as the PTE exam.
                  </p>
                </div>
              </div>
              <div className="col-md-4  la-free-mt-app-features-innerr-col2 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <svg
                    width="77"
                    height="78"
                    viewBox="0 0 77 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67 0H10C4.47715 0 0 4.47715 0 10V68C0 73.5229 4.47715 78 10 78H67C72.5229 78 77 73.5229 77 68V10C77 4.47715 72.5229 0 67 0Z"
                      fill="#E8EBFF"
                    />
                    <path
                      d="M67 0.5H10C4.75329 0.5 0.5 4.75329 0.5 10V68C0.5 73.2467 4.75329 77.5 10 77.5H67C72.2467 77.5 76.5 73.2467 76.5 68V10C76.5 4.75329 72.2467 0.5 67 0.5Z"
                      stroke="#FDEBEC"
                    />
                    <path
                      d="M57 23.4687V48.9055C56.9846 48.9228 56.9595 48.9383 56.9547 48.9585C56.393 51.2623 54.993 52.3607 52.615 52.3607C49.7254 52.3607 46.8359 52.3636 43.9463 52.3558C43.6987 52.3558 43.5223 52.4204 43.346 52.5987C42.1272 53.832 40.9025 55.0595 39.6683 56.2764C39.3994 56.5414 39.0834 56.7591 38.7895 56.999H38.2114C37.9262 56.7678 37.6198 56.5577 37.3587 56.3005C36.1331 55.0913 34.9133 53.8753 33.7079 52.6468C33.4931 52.4271 33.2782 52.3549 32.9824 52.3558C30.0321 52.3645 27.0828 52.3655 24.1325 52.3597C22.2594 52.3558 20.7564 51.2912 20.1975 49.5896C20.1233 49.3641 20.0655 49.1339 20 48.9065C20.001 40.4266 20.001 31.9476 20.001 23.4687C20.0231 23.4147 20.054 23.3627 20.0646 23.3068C20.2948 22.0619 20.9597 21.1129 22.0658 20.5126C22.4984 20.2775 22.9994 20.1677 23.4696 20C33.4902 20 43.5108 20 53.5313 20C53.5853 20.0222 53.6373 20.053 53.6932 20.0636C55.0787 20.3286 56.0683 21.1061 56.6512 22.3837C56.8083 22.7268 56.8863 23.1054 57 23.4687ZM31.7703 44.1515C31.7453 45.1381 32.5912 45.6488 33.4102 45.2239C35.0116 44.3943 36.6081 43.5532 38.2008 42.7062C38.4128 42.5935 38.5766 42.5829 38.7944 42.6995C40.3639 43.5377 41.9441 44.3587 43.5156 45.1931C43.9569 45.4272 44.3866 45.4706 44.8038 45.1642C45.2114 44.8655 45.2885 44.4425 45.2066 43.9704C44.904 42.2283 44.6063 40.4853 44.296 38.7452C44.2488 38.4812 44.3076 38.3039 44.5061 38.1141C45.7664 36.9059 47.016 35.686 48.2599 34.4614C48.4276 34.2967 48.5933 34.0982 48.6723 33.8823C48.9305 33.1828 48.4546 32.5556 47.6134 32.4351C45.8868 32.1875 44.1611 31.9351 42.4336 31.6923C42.1647 31.6547 41.999 31.5555 41.8718 31.2895C41.1174 29.718 40.3312 28.161 39.5681 26.5933C39.3445 26.1347 39.0333 25.811 38.5014 25.809C37.9696 25.8081 37.6564 26.1299 37.4329 26.5895C36.6698 28.1571 35.8855 29.7142 35.1282 31.2847C35.0029 31.5449 34.8468 31.6586 34.5713 31.6971C32.8321 31.938 31.092 32.1769 29.3577 32.4525C29.059 32.4997 28.7275 32.6587 28.5175 32.8716C28.0916 33.3023 28.1831 33.9228 28.6803 34.4084C29.9551 35.6543 31.2298 36.8991 32.5142 38.1343C32.6895 38.303 32.7531 38.4639 32.7097 38.7028C32.5459 39.5902 32.3956 40.4795 32.2434 41.3689C32.0786 42.3285 31.9168 43.2892 31.7703 44.1525V44.1515Z"
                      fill="#757AFF"
                    />
                    <path
                      d="M45.3289 34.3362C45.116 34.5298 44.9358 34.685 44.7653 34.8507C43.979 35.6128 43.1986 36.3817 42.4085 37.141C42.079 37.458 41.9431 37.8183 42.026 38.2779C42.2447 39.4968 42.4451 40.7195 42.6532 41.9402C42.6687 42.0337 42.6802 42.1281 42.7024 42.29C42.5482 42.2177 42.4355 42.1705 42.3276 42.1146C41.2735 41.5616 40.2156 41.0162 39.1692 40.4497C38.7144 40.204 38.2962 40.1982 37.8386 40.4487C36.8153 41.0075 35.7776 41.5404 34.7447 42.0828C34.6194 42.1493 34.4903 42.2091 34.2909 42.3073C34.3872 41.7292 34.4711 41.2166 34.5587 40.704C34.6888 39.9458 34.8064 39.1846 34.9576 38.4301C35.0713 37.8665 34.9191 37.4339 34.498 37.0408C33.6444 36.2439 32.8225 35.4143 31.9823 34.604C31.8975 34.5221 31.779 34.4749 31.6759 34.4113C31.701 34.3718 31.726 34.3323 31.7511 34.2928C32.3658 34.2022 32.9805 34.1107 33.5952 34.0211C34.3092 33.917 35.0241 33.8149 35.7381 33.7128C36.1909 33.6472 36.5012 33.4054 36.7016 32.9901C37.2248 31.9081 37.7624 30.8319 38.2953 29.7546C38.3521 29.6409 38.4167 29.5301 38.5101 29.3586C38.6508 29.6438 38.7655 29.876 38.8801 30.1092C39.3493 31.0573 39.8311 31.9996 40.283 32.9554C40.5142 33.4449 40.8823 33.6656 41.4045 33.734C42.6205 33.8929 43.8336 34.0779 45.0476 34.2543C45.117 34.2639 45.1844 34.2938 45.3309 34.3371L45.3289 34.3362Z"
                      fill="#757AFF"
                    />
                  </svg>
                  <h2>Score Review</h2>
                  <p>
                    Language Academy experts then review students' scorecards to
                    guide them in the areas of improvement.
                  </p>
                </div>
              </div>
              <div className="col-md-4 la-free-mt-app-features-innerr-col3 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <svg
                    width="77"
                    height="78"
                    viewBox="0 0 77 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67 0H10C4.47715 0 0 4.47715 0 10V68C0 73.5229 4.47715 78 10 78H67C72.5229 78 77 73.5229 77 68V10C77 4.47715 72.5229 0 67 0Z"
                      fill="#CCE7FF"
                    />
                    <path
                      d="M67 0.5H10C4.75329 0.5 0.5 4.75329 0.5 10V68C0.5 73.2467 4.75329 77.5 10 77.5H67C72.2467 77.5 76.5 73.2467 76.5 68V10C76.5 4.75329 72.2467 0.5 67 0.5Z"
                      stroke="#FDEBEC"
                    />
                    <path
                      d="M23 20C31.9363 20 40.8725 20 49.8088 20C49.8011 20.1439 49.7875 20.2879 49.7875 20.4318C49.7866 23.2518 49.7875 26.0718 49.7875 28.8918C49.7875 29.0329 49.7875 29.1749 49.7875 29.3546C47.2632 29.0174 45.0103 29.5787 43.0752 31.1776C41.1421 32.7755 40.1113 34.8526 40.0282 37.3663C39.9548 39.5864 40.6697 41.5485 42.1671 43.1841C44.2026 45.4089 46.7705 46.2494 49.7653 45.8833V49.2936C49.6136 49.2936 49.4832 49.2936 49.3538 49.2936C47.3617 49.2936 45.3696 49.2926 43.3766 49.2936C42.4917 49.2936 42.0425 49.7428 42.0415 50.6306C42.0396 52.6188 42.0415 54.607 42.0415 56.5952C42.0415 56.7247 42.0415 56.8541 42.0415 57H23.0222V56.4754C23.0222 44.4854 23.0222 32.4943 23.0222 20.5043C23.0213 20.3362 23.0077 20.1681 23 20ZM30.8166 29.2358H32.199C32.2715 29.0261 32.3343 28.8329 32.4048 28.6406C32.5352 28.2822 32.5729 27.7866 32.8299 27.6069C33.0917 27.4243 33.5718 27.5528 33.9573 27.5451C33.9689 27.5451 33.9853 27.5403 33.9931 27.5451C34.0955 27.6185 34.251 27.6717 34.2906 27.7712C34.4558 28.1837 34.5785 28.6126 34.735 29.029C34.7688 29.1189 34.877 29.2406 34.9572 29.2454C35.3601 29.2676 35.7658 29.2551 36.1996 29.2551C36.1561 29.1063 36.131 29.0029 36.0972 28.9025C35.5591 27.3326 35.021 25.7636 34.4819 24.1938C34.1418 23.2055 34.1418 23.2113 33.1101 23.2354C32.9246 23.2402 32.8338 23.2914 32.7748 23.474C32.5806 24.0807 32.3652 24.6807 32.1604 25.2845C31.715 26.5916 31.2716 27.8987 30.8175 29.2348L30.8166 29.2358ZM38.0583 34.1338H31.43V36.4108H38.0583V34.1338ZM31.4242 40.9592V43.2575H38.0516V40.9592H31.4242ZM37.8699 50.079V47.7952H31.431V50.079H37.8709H37.8699ZM39.4418 27.3722V29.2377H40.602V27.3664H42.3719V26.2766H40.5817V24.4237H39.4234V26.295H37.6516V27.3712H39.4408L39.4418 27.3722ZM28.9482 34.1338H26.3852V36.4176H28.9482V34.1338ZM26.389 40.9611V43.2555H28.9433V40.9611H26.389ZM28.9404 50.0828V47.7894H26.3794V50.0828H28.9404Z"
                      fill="#459AE6"
                    />
                    <path
                      d="M54.417 37.4658C54.5522 40.6916 51.8945 43.5116 48.6031 43.6352C45.3223 43.7589 42.4733 41.1475 42.3506 37.9063C42.2231 34.5125 44.7919 31.7379 48.1974 31.593C51.4936 31.4529 54.275 34.0797 54.416 37.4658H54.417ZM50.6879 40.7795C50.6773 40.6249 50.6783 40.5186 50.6609 40.4162C50.5556 39.7999 50.4522 39.1825 50.3324 38.5691C50.2851 38.3247 50.3208 38.145 50.5179 37.9643C51.0067 37.517 51.4724 37.0446 51.9448 36.5799C52.0056 36.52 52.054 36.4476 52.1303 36.3538C51.341 36.2398 50.6029 36.1249 49.8619 36.0292C49.6358 36.0003 49.5074 35.9114 49.4079 35.6979C49.09 35.0178 48.7451 34.3502 48.3828 33.6208C48.0447 34.3009 47.7133 34.9144 47.4341 35.5501C47.2844 35.8911 47.0748 36.0263 46.7096 36.064C46.0237 36.1336 45.3445 36.2563 44.7397 36.3461C45.2489 36.892 45.758 37.4532 46.2855 37.9962C46.4362 38.1517 46.4826 38.287 46.44 38.5034C46.2971 39.2434 46.1811 39.9892 46.044 40.7998C46.7289 40.4423 47.3675 40.1341 47.979 39.7796C48.2795 39.6047 48.5055 39.6163 48.8002 39.7854C49.4021 40.1322 50.029 40.4355 50.6889 40.7795H50.6879Z"
                      fill="#459AE6"
                    />
                    <path
                      d="M48.0341 51.6614C46.8005 52.8787 45.5967 54.065 44.3959 55.2485V51.6614H48.0341Z"
                      fill="#459AE6"
                    />
                    <path
                      d="M33.4859 25.2893C33.626 25.6941 33.7342 26.0071 33.853 26.352H33.1304C33.2415 26.0206 33.3468 25.7038 33.4859 25.2893Z"
                      fill="#459AE6"
                    />
                  </svg>
                  <h2>Scoring Cards</h2>
                  <p>
                    After the reviewing process, the final scorecard is ready.
                    Students have a clear understanding of their preparations
                    for the exam.
                  </p>
                </div>
              </div>
            </div>
            <div className="row text-center justify-content-center mt-md-4">
              <div className="col-md-4  la-free-mt-app-features-innerr-col4 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <svg
                    width="77"
                    height="78"
                    viewBox="0 0 77 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67 0H10C4.47715 0 0 4.47715 0 10V68C0 73.5229 4.47715 78 10 78H67C72.5229 78 77 73.5229 77 68V10C77 4.47715 72.5229 0 67 0Z"
                      fill="#D8FDFC"
                    />
                    <path
                      d="M67 0.5H10C4.75329 0.5 0.5 4.75329 0.5 10V68C0.5 73.2467 4.75329 77.5 10 77.5H67C72.2467 77.5 76.5 73.2467 76.5 68V10C76.5 4.75329 72.2467 0.5 67 0.5Z"
                      stroke="#FDEBEC"
                    />
                    <path
                      d="M57.0069 37.415H39.5857V20C40.2849 20 40.9831 20 41.6822 20C41.7749 20.0203 41.8676 20.0531 41.9613 20.0599C44.7821 20.2761 47.374 21.171 49.7043 22.7619C53.4869 25.3452 55.8548 28.8861 56.7258 33.3991C56.8485 34.0333 56.9141 34.6792 57.0069 35.3192V37.415Z"
                      fill="#09CECA"
                    />
                    <path
                      d="M52.5782 39.5822C52.948 46.5076 49.1722 52.6598 43.1578 55.4748C37.0334 58.3409 30.2947 56.9942 25.6671 52.8847C25.754 52.7911 25.838 52.6955 25.9288 52.6048C30.1788 48.3553 34.4318 44.1068 38.6779 39.8525C38.8701 39.6594 39.0604 39.5754 39.3356 39.5764C43.6127 39.5851 47.8888 39.5822 52.1658 39.5822H52.5782V39.5822Z"
                      fill="#09CECA"
                    />
                    <path
                      d="M35.8484 39.5551C31.918 43.4851 28.0186 47.3832 24.12 51.2803C18.8976 45.801 18.012 35.7014 25.2084 28.859C28.7535 32.4221 32.2995 35.9872 35.8484 39.5551Z"
                      fill="#09CECA"
                    />
                    <path
                      d="M37.4042 24.429V37.8841C33.9354 34.4166 30.4425 30.9249 26.9583 27.4419C29.6603 25.3828 33.497 24.207 37.4042 24.43V24.429Z"
                      fill="#09CECA"
                    />
                  </svg>
                  <h2>Report Analysis</h2>
                  <p>
                    The final report provides feedback to the students on how to
                    achieve their targeted PTE score and improvements needed to
                    appear in the final exam.
                  </p>
                </div>
              </div>
              <div className="col-md-4 la-free-mt-app-features-innerr-col5 la-free-mt-app-features-innerr-col">
                <div className="la-inner-col">
                  <svg
                    width="77"
                    height="78"
                    viewBox="0 0 77 78"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M67 0H10C4.47715 0 0 4.47715 0 10V68C0 73.5229 4.47715 78 10 78H67C72.5229 78 77 73.5229 77 68V10C77 4.47715 72.5229 0 67 0Z"
                      fill="#FFF0D9"
                    />
                    <path
                      d="M67 0.5H10C4.75329 0.5 0.5 4.75329 0.5 10V68C0.5 73.2467 4.75329 77.5 10 77.5H67C72.2467 77.5 76.5 73.2467 76.5 68V10C76.5 4.75329 72.2467 0.5 67 0.5Z"
                      stroke="#FDEBEC"
                    />
                    <path
                      d="M20 32.1446C20.1454 31.8226 20.2454 31.4699 20.4445 31.1844C20.9185 30.5034 21.6237 30.248 22.4431 30.249C25.3332 30.2514 28.2228 30.2519 31.1129 30.249C32.2364 30.248 33.1367 30.678 33.8305 31.5531C34.6909 32.6389 35.5715 33.709 36.425 34.8001C36.5935 35.0156 36.766 35.0822 37.0286 35.0788C38.0521 35.0662 39.0756 35.0725 40.099 35.0769C40.8702 35.0798 41.2201 35.4578 41.2556 36.2195C41.3162 37.5154 40.9481 37.854 39.6467 37.8073C38.5281 37.7674 37.4065 37.7776 36.2875 37.8073C35.6104 37.8253 35.1127 37.5908 34.717 37.0509C34.2514 36.4161 33.7394 35.8143 33.2599 35.1893C33.0529 34.9193 32.8213 34.7437 32.4651 34.8507C32.0822 34.966 32.1162 35.2861 32.1157 35.5833C32.1068 41.9425 32.0984 48.3017 32.0896 54.6614C32.0896 54.8156 32.092 54.9713 32.0768 55.1245C32.0304 55.5925 31.684 55.9568 31.2105 55.9763C30.5975 56.0016 29.9825 56.0011 29.3695 55.9787C28.8817 55.9612 28.5269 55.5998 28.4682 55.1138C28.4529 54.9844 28.4589 54.8526 28.4589 54.7222C28.4589 52.2025 28.4589 49.6822 28.4579 47.1625C28.4579 47.0321 28.4682 46.8979 28.4431 46.7714C28.3909 46.5072 28.2189 46.3477 27.9429 46.3443C27.6699 46.3409 27.4847 46.481 27.4334 46.7534C27.4073 46.892 27.4038 47.0365 27.4038 47.1785C27.4024 49.6628 27.4029 52.147 27.4024 54.6313C27.4024 54.7621 27.4038 54.893 27.393 55.0233C27.3442 55.5983 26.9712 55.9675 26.3887 55.986C25.8477 56.003 25.3047 56.0025 24.7636 55.9875C24.1654 55.9709 23.7899 55.5847 23.7643 54.9893C23.7593 54.8706 23.7628 54.7514 23.7628 54.6327C23.7613 48.2973 23.7603 41.9615 23.7583 35.6261C23.7583 35.484 23.7997 35.3045 23.7293 35.2077C23.6169 35.0531 23.4282 34.8575 23.2705 34.856C23.1168 34.8551 22.929 35.0535 22.8176 35.2073C22.7467 35.3055 22.7792 35.4831 22.7792 35.6246C22.7772 37.978 22.7753 40.3319 22.7802 42.6853C22.7812 43.1143 22.6915 43.4884 22.2855 43.7214C21.5709 44.131 20.3927 43.8265 20 43.1309C20 39.469 20 35.8066 20 32.1446Z"
                      fill="#FAB750"
                    />
                    <path
                      d="M41.2438 38.4041C42.5146 37.4045 42.7368 36.4618 42.0391 35.1839C42.1248 35.0769 42.218 34.9567 42.3145 34.84C43.4252 33.4954 44.5379 32.1529 45.6457 30.8059C45.758 30.6692 45.8763 30.5199 45.9275 30.3569C46.0118 30.0894 45.9384 29.8365 45.7043 29.6545C45.4599 29.4648 45.1884 29.4497 44.9311 29.6093C44.7927 29.6949 44.6779 29.8272 44.5719 29.9547C43.4198 31.3425 42.2677 32.7308 41.127 34.1273C40.9722 34.317 40.8264 34.3506 40.582 34.3409C39.5723 34.3015 38.5606 34.2869 37.5505 34.3059C37.173 34.3132 36.9552 34.1808 36.7078 33.9099C36.2673 33.4273 36.1269 32.9112 36.1367 32.2667C36.1727 29.9731 36.15 27.6791 36.151 25.385C36.151 24.4272 36.4787 24.1081 37.4588 24.1081C43.5391 24.1081 49.6193 24.1081 55.6996 24.1081C56.6694 24.1081 56.9995 24.4355 57 25.3914C57 29.3135 57 33.2357 57 37.1579C57 38.0602 56.6516 38.4036 55.7326 38.4036C51.037 38.4041 46.3414 38.4036 41.6459 38.4036C41.5409 38.4036 41.4359 38.4036 41.2438 38.4036V38.4041Z"
                      fill="#FAB750"
                    />
                    <path
                      d="M27.9006 28.9682C25.6329 28.9181 23.8589 27.1105 23.9062 24.8977C23.9535 22.696 25.8019 20.9502 28.0336 20.9998C30.288 21.0499 32.0507 22.8765 31.9901 25.1C31.9314 27.2622 30.0771 29.0163 27.9011 28.9682H27.9006Z"
                      fill="#FAB750"
                    />
                  </svg>
                  <h2>Expert Tutor Support</h2>
                  <p>
                    Language Academy tutors are available to help a student
                    provide their guidance in the important areas of the PTE
                    exam.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="inner-page-fourth-section py-60">
          <div className="container">
            <div className="sec-title text-center">
              <h2 className="title-h2">
                Language Academy Hones in All Question Types
              </h2>
              <hr className="title-divider divider-blue"></hr>
            </div>
            <div className="row tabRow">
              <div className="col-md-3 tabRowcol tabLinkRowcol">
                <div className="ed_tab">
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="ed_tablinks mb-3 p-3 shadow active show"
                        href="tab1"
                        id="edDefaultOpen"
                      >
                        Full Length Scored Mock Test
                      </button>
                    </div>
                    <div className="col-md-12">
                      <button
                        className="ed_tablinks mb-3 p-3 shadow"
                        href="tab2"
                      >
                        Section-wise PTE Practice Test
                      </button>
                    </div>
                    <div className="col-md-12">
                      <button
                        className="ed_tablinks mb-3 p-3 shadow"
                        href="tab3"
                      >
                        Sample answers
                      </button>
                    </div>
                    <div className="col-md-12">
                      <button
                        className="ed_tablinks mb-3 p-3 shadow"
                        href="tab4"
                      >
                        Detail analysis
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 tabRowcol tabContentRowcol">
                <div className="row">
                  <div className="col-md-12">
                    <div
                      id="tab1"
                      className="container ed_tabcontent tab-pane fade shadow rounded bg-white show active p-0"
                    >
                      <img
                        src="images/dash_img_01_resized.jpg"
                        alt="Application Screen"
                        className="ed_tabcontent_image"
                        loading="lazy"
                      />
                    </div>
                    <div
                      id="tab2"
                      className="container ed_tabcontent tab-pane shadow rounded bg-white p-0"
                    >
                      <img
                        src="images/Section-Wise-PTE-Practice-Test_resized.jpg"
                        alt="Application Screen"
                        className="ed_tabcontent_image"
                        loading="lazy"
                      />
                    </div>
                    <div
                      id="tab3"
                      className="container ed_tabcontent tab-pane shadow rounded bg-white p-0"
                    >
                      <img
                        src="images/Sample-Answers-20task_resized.jpg"
                        alt="Application Screen"
                        className="ed_tabcontent_image"
                        loading="lazy"
                      />
                    </div>
                    <div
                      id="tab4"
                      className="container ed_tabcontent tab-pane shadow rounded bg-white p-0"
                    >
                      <img
                        src="images/Detailed-Analysis-20task.jpg"
                        alt="Application Screen"
                        className="ed_tabcontent_image"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="la-free-mt-app-free-tial-section py-40"
          id="la-free-mt-app-free-tial-section"
        >
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40 mb-45">
                  <h2>Why choose Language Academy for PTE Mock Test?</h2>
                  <p>
                    Our PTE Online Mock Test is specially designed to give you
                    an edge while preparing for the exam. You can easily rely on
                    us for your PTE exam preparation as we have:
                  </p>
                </div>
              </div>
            </div>
            <div className="row languages-border-top text-center languages-box-second-row">
              <div className="col col-md-4">
                <div className="language-box">
                  <img
                    src="https://www.languageacademy.com.au/images/experienced-trainer.png"
                    alt="Experienced Trainer"
                  />
                  <h2>Experienced Trainer</h2>
                  <p>We have Pearson certified faculty members...</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="language-box">
                  <img
                    src="https://www.languageacademy.com.au/images/star-ribben.png"
                    alt="Highest Success Rate"
                  />
                  <h2>Highest Success Rate</h2>
                  <p>Students will get a sure-shot success with the high...</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="language-box">
                  <img
                    src="  https://www.languageacademy.com.au/images/real-test.png"
                    alt="Online Support"
                  />
                  <h2>Real Time Test Environment</h2>
                  <p>We provide several mock tests for reading, listening...</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="language-box">
                  <img
                    src="https://www.languageacademy.com.au/images/settings.png"
                    alt="Latest Resources"
                  />
                  <h2>Latest Resources</h2>
                  <p>Making use of the latest technology, we provide...</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="language-box">
                  <img
                    src="https://www.languageacademy.com.au/images/star-ribben.png"
                    alt="Online Support"
                  />
                  <h2>In-depth Analysis</h2>
                  <p>
                    Each response is evaluated individually, so students learn
                    quickly.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="language-box">
                  <img
                    src="https://www.languageacademy.com.au/images/support.png"
                    alt="Online Support"
                  />
                  <h2>Question wise Feedback</h2>
                  <p>
                    The portal keeps the record of all the attempted questions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="package py-40 mb-0" id="package">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>Packages</h2>
                  <p>
                    Language Academy provides 2 packages ( Silver and Gold ) which include study material, Free mock tests with a scorecard and proper feedback.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Plans />
          {/*{this.state.plans.length > 0 && <PackagesTabs plans={this.state.plans} />}*/}
          {/*<div className="container packagesWrap">
            <div className="row">
              <div className="col-md-4 darkVersion mb-4 mb-md-0">
                <div className="packageCol">
                  <div className="row">
                    <div className="col">
                      <div className="packageHead d-flex justify-content-between align-items-center w-100">
                        <div className="packageHeadLeft">
                          <h5 className="m-0">
                            <b>SILVER</b>
                          </h5>
                          <p className="m-0">Video Course</p>
                        </div>
                        <div className="packageHeadRight">
                          <div className="priceBox">
                            <h6 className="m-0">$89</h6>
                            <p className="m-0">
                              <small>1 month</small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col">
                      <div className="customDivider my-4"></div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="packageContent">
                        <ul>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>
                              1 month (Renewed every 1 month) Practice portal
                              access
                            </span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>Real exam practice questions</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>Proven tricks and templates</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>1 Full length mock test with score</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>
                              1 In-depth feedback for the full length mock test
                            </span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>1 Month Complete video course</span>
                          </li>
                          <li className="mb-2">&nbsp;</li>
                        </ul>
                        <Link to="/sub/payment/form/8" className="selectPlan">
                          Buy Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 darkVersion mb-4 mb-md-0">
                <div className="packageCol">
                  <div className="row">
                    <div className="col">
                      <div className="packageHead d-flex justify-content-between align-items-center w-100">
                        <div className="packageHeadLeft">
                          <h5 className="m-0">
                            <b>Plus</b>
                          </h5>
                          <p className="m-0">Video Course</p>
                        </div>
                        <div className="packageHeadRight">
                          <div className="priceBox">
                            <h6 className="m-0">$299</h6>
                            <p className="m-0">
                              <small>2 months</small>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col">
                      <div className="customDivider my-4"></div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="packageContent">
                        <ul>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>
                              2 months (Renewed every 2 months) Practice portal
                              access
                            </span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>Real exam practice questions</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>Proven tricks and templates</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>2 Full length mock test with score</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>
                              2 In-depth feedback for the full length mock test
                            </span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>One 1-1 tutorial with a PTE expert</span>
                          </li>
                          <li className="mb-2">
                            <i className="fa fa-check-circle mr-2"></i>
                            <span>2 Months Complete video course</span>
                          </li>
                        </ul>
                        <Link to="/sub/payment/form/2" className="selectPlan">
                          Buy Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>*/}
        </section>
        <section className="success-numbers py-40 mb-0" id="success-numbers">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>Success Numbers</h2>
                  <p>
                    The student's success is the success of the Language
                    Academy. Language Academy aims to provide a good quality of
                    assistance to the students appearing for the PTE exams. 14
                    out of 15 students scored 90 plus in the PTE exams with
                    Language Academy.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="four col-md-3">
                <div className="counter-box">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9059 35.9979C8.8762 35.969 6.40046 35.6407 4.09154 34.5135C3.2551 34.1053 2.49512 33.5839 1.8869 32.8671C1.2949 32.1723 0.98094 31.3792 0.996001 30.4531C1.04698 27.5627 1.99232 25.01 3.86332 22.8029C4.46343 22.0954 5.29987 21.9901 5.92083 22.5197C6.5418 23.0492 6.56844 23.8885 5.97528 24.5938C4.60245 26.2309 3.88533 28.1165 3.76716 30.2461C3.7382 30.7687 3.90734 31.1872 4.33251 31.4208C5.10988 31.8486 5.89187 32.3295 6.73527 32.5677C10.2328 33.5562 13.7466 33.5735 17.1375 32.1792C19.4024 31.2474 19.1777 30.8913 18.8846 28.949C18.6343 27.2864 17.8941 25.8308 16.7981 24.5556C16.1922 23.8504 16.2165 23.0203 16.8491 22.485C17.4666 21.9612 18.2914 22.0514 18.8776 22.7312C20.8529 25.0204 21.8284 27.683 21.804 30.7017C21.7971 31.6277 21.3812 32.3954 20.7556 33.0532C19.7106 34.1527 18.3818 34.7701 16.9626 35.2141C15.2503 35.7505 13.4152 35.9979 10.9048 35.9991L10.9059 35.9979Z"
                      fill="black"
                    />
                    <path
                      d="M17.6484 6.9083C17.6658 3.07222 20.788 -0.0216064 24.618 -0.000795896C28.4585 0.0200146 31.5332 3.12772 31.5204 6.9742C31.5088 10.7814 28.36 13.8648 24.5091 13.8417C20.7347 13.8197 17.631 10.6831 17.6484 6.90714V6.9083ZM28.7458 6.9372C28.7527 4.64573 26.8887 2.76816 24.6029 2.767C22.3056 2.76585 20.4369 4.61452 20.423 6.90367C20.4091 9.18705 22.2824 11.0716 24.567 11.0727C26.869 11.075 28.7377 9.22405 28.7446 6.9372H28.7458Z"
                      fill="black"
                    />
                    <path
                      d="M4.46802 15.2533C4.46802 11.4311 7.56472 8.30954 11.3565 8.30492C15.2318 8.30145 18.3389 11.3883 18.34 15.2441C18.34 19.0582 15.2121 22.1566 11.3658 22.1497C7.58673 22.1428 4.46686 19.0223 4.46802 15.2522V15.2533ZM11.4052 19.3807C13.7048 19.3761 15.5654 17.5194 15.5666 15.2279C15.5666 12.9399 13.6944 11.0693 11.4075 11.075C9.09511 11.0808 7.23339 12.9572 7.24497 15.2718C7.25656 17.5298 9.13566 19.3854 11.4063 19.3807H11.4052Z"
                      fill="black"
                    />
                    <path
                      d="M25.1799 27.6899C25.0212 27.6899 24.8625 27.6899 24.7026 27.6899C23.8279 27.6864 23.1977 27.1049 23.1989 26.3025C23.2 25.5141 23.8082 24.9325 24.6632 24.9233C26.0847 24.9071 27.4888 24.7626 28.864 24.3961C29.8302 24.1383 30.7605 23.7937 31.5784 23.196C32.0302 22.8653 32.2573 22.4665 32.2213 21.8757C32.0927 19.7449 31.3698 17.8593 29.9692 16.243C29.6263 15.8476 29.4363 15.4175 29.566 14.8961C29.6993 14.3619 30.0457 14.0035 30.5786 13.8752C31.1277 13.7422 31.6039 13.9076 31.9839 14.3353C33.2814 15.7979 34.1943 17.4696 34.6287 19.3726C34.8199 20.2097 34.901 21.0768 34.9798 21.9347C35.0956 23.1948 34.5615 24.2018 33.6475 25.032C32.4032 26.1603 30.8948 26.7835 29.2903 27.135C27.9418 27.4309 26.5609 27.5766 25.1938 27.7893C25.188 27.757 25.1834 27.7234 25.1776 27.6911L25.1799 27.6899Z"
                      fill="black"
                    />
                    <path
                      d="M28.747 6.9372C28.74 9.22404 26.8702 11.075 24.5694 11.0727C22.2836 11.0704 20.4115 9.18705 20.4254 6.90367C20.4393 4.61451 22.308 2.76584 24.6053 2.767C26.8899 2.76815 28.7551 4.64457 28.7481 6.9372H28.747Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M11.4041 19.3807C9.13342 19.3854 7.25431 17.5298 7.24273 15.2718C7.23114 12.9584 9.09287 11.0808 11.4053 11.075C13.6922 11.0692 15.5655 12.9399 15.5643 15.2279C15.5643 17.5194 13.7026 19.375 11.4029 19.3807H11.4041Z"
                      fill="#99C83D"
                    />
                  </svg>
                  <span className="counter fig-number">500000</span>
                  <p>
                    <b>Members</b>
                  </p>
                </div>
              </div>
              <div className="four col-md-3">
                <div className="counter-box">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.59728 3.59928C5.59728 3.00875 5.59528 2.46125 5.59728 1.91475C5.60329 0.764698 6.35097 0.00400365 7.49101 0.00300274C11.4496 0 15.4092 0.00300274 19.3678 0C19.9524 0 20.4348 0.205187 20.8302 0.633578C22.9721 2.9567 25.1141 5.27882 27.259 7.59893C27.6164 7.98529 27.7825 8.4347 27.7805 8.96018C27.7755 10.8709 27.7835 12.7827 27.7735 14.6934C27.7725 14.9687 27.8166 15.0948 28.1308 15.1618C31.1486 15.8024 33.3236 18.5219 33.3166 21.6087C33.3086 24.7146 31.1346 27.403 28.1138 28.0426C28.0067 28.0656 27.9016 28.0986 27.7795 28.1317C27.7795 28.8934 27.7795 29.642 27.7795 30.3907C27.7775 31.6579 27.0499 32.3785 25.7737 32.3805C25.2622 32.3805 24.7508 32.3805 24.1832 32.3805C24.1832 32.5767 24.1742 32.7579 24.1842 32.9391C24.3324 35.4844 23.6688 36.0289 21.1285 35.9988C15.4473 35.9328 9.76509 35.9788 4.0829 35.9778C2.69964 35.9778 2.002 35.2862 2.002 33.9129C2 24.4964 2 15.0788 2 5.66117C2 4.30693 2.70064 3.60029 4.04587 3.59928C4.54432 3.59928 5.04278 3.59928 5.59728 3.59928ZM19.3678 1.2011C19.2047 1.2011 19.0696 1.2011 18.9345 1.2011C15.188 1.2011 11.4416 1.2011 7.6942 1.2011C6.95552 1.2011 6.79638 1.36024 6.79638 2.10192C6.79638 11.4955 6.79638 20.8881 6.79638 30.2816C6.79638 31.0213 6.95652 31.1825 7.6952 31.1825C13.6897 31.1825 19.6841 31.1825 25.6786 31.1825C25.7537 31.1825 25.8287 31.1845 25.9038 31.1825C26.3472 31.1674 26.5714 30.9512 26.5784 30.5088C26.5864 29.9964 26.5804 29.4849 26.5804 28.9724C26.5804 28.7172 26.5804 28.461 26.5804 28.3018C25.8087 28.1217 25.1211 27.9555 24.4295 27.8054C24.3084 27.7793 24.1592 27.7924 24.0451 27.8394C23.4215 28.0936 22.809 28.3729 22.1854 28.6281C21.707 28.8243 21.2476 28.7763 20.8622 28.4139C20.4769 28.0516 20.4028 27.6012 20.5669 27.1077C20.643 26.8765 20.7251 26.6473 20.8152 26.3881H20.3557C18.1207 26.3881 15.8847 26.3881 13.6496 26.3881C13.5245 26.3881 13.3954 26.4011 13.2763 26.3721C12.977 26.298 12.7959 26.0998 12.7989 25.7845C12.8019 25.4702 12.983 25.2731 13.2853 25.205C13.4044 25.178 13.5335 25.19 13.6586 25.19C16.0068 25.19 18.3539 25.19 20.7021 25.19H21.1715C20.4478 24.0549 20.1255 22.8699 20.0975 21.5927H19.6391C17.6663 21.5927 15.6925 21.5927 13.7197 21.5927C13.0791 21.5927 12.7878 21.4015 12.7948 20.9841C12.8019 20.5698 13.0821 20.3936 13.7377 20.3936C15.124 20.3936 16.5102 20.3936 17.8965 20.3936H20.2066C20.4839 19.0103 21.1315 17.8313 22.1724 16.7963H21.6659C19.0055 16.7963 16.3461 16.7963 13.6857 16.7963C13.5605 16.7963 13.4324 16.8093 13.3123 16.7853C12.991 16.7233 12.7969 16.5231 12.8009 16.1908C12.8049 15.8595 13.001 15.6613 13.3243 15.6062C13.4454 15.5852 13.5736 15.5972 13.6987 15.5972C16.9957 15.5972 20.2927 15.5972 23.5897 15.5972C23.7148 15.5972 23.8459 15.6152 23.963 15.5832C24.8208 15.353 25.6766 15.1118 26.5554 14.8666V9.00121C26.3933 9.00121 26.2571 9.00121 26.121 9.00121C24.4975 9.00121 22.874 9.00221 21.2506 9.00121C20.5439 9.00121 19.9834 8.70494 19.6451 8.08638C19.511 7.84115 19.3648 7.79812 19.1216 7.79912C16.8365 7.80612 14.5505 7.80612 12.2654 7.80212C11.3165 7.80012 10.5858 7.20958 10.4267 6.31176C10.3837 6.06854 10.3967 5.81431 10.3967 5.56508C10.3967 4.34496 11.1353 3.60729 12.3565 3.60729C14.5545 3.60529 16.7525 3.60729 18.9505 3.60729C19.0846 3.60729 19.2177 3.60729 19.3698 3.60729V1.2011H19.3678ZM5.59728 4.84842C5.53723 4.8234 5.51621 4.80639 5.49419 4.80639C5.03177 4.80238 4.57035 4.80038 4.10792 4.79938C3.36024 4.79938 3.19909 4.95652 3.19909 5.68819C3.19909 15.0928 3.19909 24.4984 3.19909 33.9029C3.19909 34.6136 3.36625 34.7787 4.0839 34.7787C10.0904 34.7787 16.0969 34.7787 22.1033 34.7787C22.2154 34.7787 22.3296 34.7877 22.4397 34.7717C22.7469 34.7247 22.9581 34.5425 22.9701 34.2322C22.9932 33.6257 22.9771 33.0171 22.9771 32.3805H22.4977C17.5522 32.3805 12.6077 32.3805 7.66217 32.3805C6.29092 32.3805 5.59728 31.6819 5.59628 30.3006C5.59628 21.9821 5.59628 13.6635 5.59628 5.34588V4.84742L5.59728 4.84842ZM21.681 27.5421C22.4577 27.2088 23.1483 26.9226 23.8289 26.6163C24.1232 26.4842 24.3884 26.4802 24.6887 26.6043C25.6456 26.9996 26.6385 27.0847 27.6604 26.9176C30.2788 26.4892 32.2596 24.0159 32.1105 21.3505C31.9553 18.584 29.7443 16.3129 27.0579 16.2008C24.8448 16.1087 23.1043 17.0035 22.0143 18.9343C20.9263 20.862 21.0514 22.8078 22.2675 24.6625C22.4737 24.9758 22.5197 25.2631 22.3856 25.6094C22.1494 26.2209 21.9352 26.8415 21.681 27.5421ZM20.585 2.13495C20.585 3.8395 20.585 5.42395 20.585 7.0094C20.585 7.59693 20.7841 7.79611 21.3697 7.79711C22.7299 7.79912 24.0902 7.79711 25.4504 7.79711C25.5425 7.79711 25.6346 7.7831 25.7837 7.77009C24.0471 5.88837 22.3516 4.0507 20.584 2.13595L20.585 2.13495ZM19.3688 4.79938C16.9687 4.79938 14.6115 4.79538 12.2554 4.80839C12.0872 4.80839 11.859 4.88546 11.7619 5.00857C11.4716 5.3729 11.5467 5.81831 11.6558 6.22168C11.7549 6.58601 12.0972 6.60102 12.4255 6.60102C14.6205 6.59702 16.8155 6.59902 19.0105 6.59802C19.1296 6.59802 19.2497 6.58701 19.3698 6.58201V4.80038L19.3688 4.79938Z"
                      fill="black"
                    />
                    <path
                      d="M21.681 27.5421C21.9352 26.8415 22.1494 26.2209 22.3856 25.6094C22.5197 25.2631 22.4737 24.9768 22.2675 24.6625C21.0514 22.8078 20.9253 20.862 22.0143 18.9343C23.1043 17.0035 24.8449 16.1087 27.0579 16.2008C29.7443 16.3129 31.9553 18.584 32.1105 21.3505C32.2596 24.0159 30.2788 26.4882 27.6604 26.9176C26.6385 27.0847 25.6456 26.9996 24.6887 26.6043C24.3884 26.4802 24.1232 26.4842 23.8289 26.6163C23.1483 26.9226 22.4577 27.2088 21.681 27.5421ZM26.7906 17.517C26.7846 17.538 26.7786 17.559 26.7736 17.579C26.6245 17.5921 26.4733 17.5921 26.3272 17.6211C25.6626 17.7502 25.0911 18.0094 24.8419 18.7111C24.7257 19.0384 24.7878 19.3036 25.0901 19.4848C25.3653 19.6489 25.6246 19.5739 25.8488 19.2506C26.152 18.8142 26.5654 18.7001 27.0609 18.7941C27.7175 18.9203 27.9437 19.5158 27.5093 20.0253C27.3091 20.2595 27.0479 20.4407 26.8126 20.6438C26.2551 21.1233 26.056 21.7328 26.14 22.4535C26.1771 22.7728 26.3632 22.9049 26.6605 22.9249C27.0389 22.9499 27.2981 22.7858 27.2871 22.4084C27.2691 21.7759 27.6104 21.3985 28.0508 21.0382C28.289 20.843 28.5072 20.6098 28.6894 20.3606C29.337 19.4718 29.0417 18.2947 28.0398 17.8543C27.6494 17.6831 27.209 17.6261 26.7916 17.516L26.7906 17.517ZM27.4672 24.4443C27.4692 24.0229 27.1039 23.6466 26.6905 23.6456C26.2752 23.6436 25.9128 24.0139 25.9118 24.4393C25.9118 24.8627 26.2742 25.239 26.6855 25.241C27.0929 25.243 27.4652 24.8637 27.4672 24.4443Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M19.3679 4.79938V6.58101C19.2478 6.58701 19.1287 6.59702 19.0086 6.59702C16.8136 6.59702 14.6186 6.59602 12.4236 6.60002C12.0953 6.60002 11.7529 6.58601 11.6538 6.22068C11.5437 5.81731 11.4697 5.3719 11.7599 5.00757C11.858 4.88446 12.0852 4.80839 12.2534 4.80739C14.6095 4.79438 16.9667 4.79838 19.3669 4.79838L19.3679 4.79938Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M19.0526 11.9939C17.2669 11.9939 15.4813 11.9939 13.6947 11.9939C13.5826 11.9939 13.4695 11.9999 13.3574 11.9889C13.0251 11.9549 12.7959 11.7117 12.7939 11.3984C12.7908 11.0861 13.0191 10.8369 13.3484 10.7999C13.4474 10.7888 13.5475 10.7948 13.6476 10.7948C17.2689 10.7948 20.8912 10.7948 24.5125 10.7948C24.6246 10.7948 24.7398 10.7838 24.8489 10.8029C25.1721 10.8599 25.3683 11.0581 25.3713 11.3884C25.3743 11.7197 25.1792 11.9199 24.8579 11.9829C24.7488 12.004 24.6337 11.9929 24.5216 11.9929C22.6979 11.9929 20.8752 11.9929 19.0516 11.9929L19.0526 11.9939Z"
                      fill="black"
                    />
                    <path
                      d="M11.5918 11.3984C11.7019 12.7556 11.1504 13.2191 9.79915 13.2181C8.44992 13.2171 7.96648 12.7797 7.97048 11.3724C7.97449 10.0472 8.44392 9.48566 9.77013 9.59476C9.91926 9.60677 10.0694 9.59576 10.2195 9.59676C11.1294 9.59876 11.5908 10.0662 11.5928 10.987C11.5928 11.1242 11.5928 11.2613 11.5928 11.3994L11.5918 11.3984ZM10.3677 11.9769V10.8239H9.21262V11.9769H10.3677Z"
                      fill="black"
                    />
                    <path
                      d="M9.78505 14.3931C11.1413 14.283 11.6177 14.8085 11.6157 16.2118C11.6137 17.551 11.1353 18.0985 9.81909 17.9934C9.59588 17.9754 9.36968 17.9984 9.14547 17.9874C8.51189 17.9544 8.02044 17.4629 7.99842 16.8274C7.98441 16.428 7.98942 16.0286 7.99642 15.6293C8.00843 14.9106 8.50889 14.4101 9.22354 14.3941C9.41071 14.3901 9.59788 14.3941 9.78505 14.3941V14.3931ZM10.3746 15.6132H9.21754V16.7643H10.3746V15.6132Z"
                      fill="black"
                    />
                    <path
                      d="M9.79514 19.1895C11.1564 19.0764 11.6158 19.6349 11.6168 20.9801C11.6168 22.3404 11.1734 22.8138 9.77412 22.8118C8.4359 22.8088 7.8864 22.3314 7.9935 21.0152C8.00851 20.829 7.9935 20.6408 7.9965 20.4537C8.00751 19.693 8.50597 19.1995 9.27167 19.1905C9.44683 19.1885 9.62098 19.1905 9.79614 19.1905L9.79514 19.1895ZM9.21261 21.5627H10.3657V20.4066H9.21261V21.5627Z"
                      fill="black"
                    />
                    <path
                      d="M9.79115 23.9869C11.1634 23.8728 11.6138 24.4403 11.6158 25.7735C11.6178 27.1438 11.1664 27.6102 9.77714 27.6092C8.43091 27.6092 7.88641 27.1237 7.99251 25.8166C8.00852 25.6184 7.99151 25.4172 7.99551 25.218C8.01153 24.5024 8.51098 24.0039 9.22864 23.9889C9.41581 23.9849 9.60298 23.9889 9.79015 23.9889L9.79115 23.9869ZM10.3757 25.207H9.21863V26.3581H10.3757V25.207V25.207Z"
                      fill="black"
                    />
                    <path
                      d="M26.7897 17.516C27.207 17.6251 27.6474 17.6821 28.0378 17.8543C29.0397 18.2947 29.335 19.4718 28.6874 20.3606C28.5062 20.6098 28.287 20.843 28.0488 21.0382C27.6074 21.3985 27.2661 21.7769 27.2851 22.4084C27.2961 22.7858 27.0369 22.9499 26.6585 22.9249C26.3613 22.9049 26.1751 22.7718 26.1381 22.4535C26.055 21.7328 26.2542 21.1243 26.8107 20.6438C27.0459 20.4407 27.3081 20.2595 27.5073 20.0253C27.9417 19.5168 27.7145 18.9203 27.0589 18.7942C26.5645 18.6991 26.1511 18.8132 25.8468 19.2506C25.6226 19.5739 25.3624 19.6489 25.0881 19.4848C24.7858 19.3036 24.7228 19.0384 24.8399 18.7111C25.0901 18.0094 25.6606 17.7502 26.3252 17.6211C26.4714 17.5931 26.6225 17.5931 26.7716 17.579C26.7776 17.558 26.7837 17.537 26.7887 17.517L26.7897 17.516Z"
                      fill="black"
                    />
                    <path
                      d="M27.4663 24.4443C27.4643 24.8637 27.092 25.243 26.6846 25.241C26.2732 25.239 25.9099 24.8627 25.9109 24.4393C25.9109 24.0129 26.2742 23.6436 26.6896 23.6456C27.103 23.6476 27.4683 24.0229 27.4663 24.4443Z"
                      fill="black"
                    />
                    <path
                      d="M10.3677 11.9759H9.21265V10.8229H10.3677V11.9759Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M10.3757 15.6133V16.7643H9.21863V15.6133H10.3757Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M9.21155 21.5627V20.4066H10.3646V21.5627H9.21155Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M10.3757 25.207V26.3581H9.21863V25.207H10.3757V25.207Z"
                      fill="#99C83D"
                    />
                  </svg>

                  <span className="counter fig-number">11000</span>
                  <p>
                    <b>Practice Questions</b>
                  </p>
                </div>
              </div>
              <div className="four col-md-3">
                <div className="counter-box">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 35.9991V0H31.3823V0.390048C31.3823 10.6262 31.3813 20.8624 31.3879 31.0986C31.3879 31.3664 31.3099 31.5516 31.121 31.7396C29.7788 33.0667 28.447 34.405 27.1134 35.7406C27.0316 35.8224 26.9583 35.9135 26.8803 36H23.4328C23.4516 35.6635 23.4704 35.327 23.4911 34.9502H26.0992V30.7348H30.3071V1.0536H6.0724V34.9257H20.2739C20.2965 35.3083 20.3162 35.6541 20.3369 36H5V35.9991ZM27.1801 34.0225C27.9132 33.2894 28.6773 32.5243 29.4029 31.7978H27.1801V34.0225V34.0225Z"
                      fill="black"
                    />
                    <path
                      d="M21.3219 35.9991C21.3416 35.6551 21.3613 35.3101 21.3811 34.9558H22.3877C22.4084 35.3111 22.4272 35.6551 22.4469 35.9991H21.3209H21.3219Z"
                      fill="black"
                    />
                    <path
                      d="M19.7777 10.3161H16.6272C16.5248 9.03501 16.8349 7.8799 17.6338 6.87142C18.9337 5.22946 21.1095 4.63264 23.0419 5.37326C24.9968 6.12328 26.2534 8.0284 26.0899 10.1177C25.9423 12.0022 24.9705 13.3584 23.2514 14.1592C23.0419 14.2569 22.9347 14.3444 22.93 14.6056C22.915 15.4778 22.1866 16.1611 21.335 16.1452C20.4751 16.1292 19.7927 15.4402 19.7767 14.5605C19.7683 14.0915 19.7739 13.6225 19.7748 13.1535C19.7767 12.0717 20.3576 11.4533 21.4356 11.3838C22.4695 11.317 23.1556 10.3583 22.8746 9.3743C22.6668 8.64966 21.945 8.15059 21.2204 8.23047C20.4262 8.31882 19.8247 8.9335 19.7786 9.71078C19.7673 9.90627 19.7767 10.1027 19.7767 10.3151L19.7777 10.3161ZM21.8849 13.5276C23.6293 12.7926 23.9676 12.5765 24.4404 11.8377C25.0334 10.9119 25.1998 9.91379 24.916 8.84515C24.4592 7.1233 22.7392 5.92778 21.0155 6.13455C19.2777 6.34415 17.7786 7.76524 17.7438 9.25776H18.7645C18.8011 9.14497 18.8331 9.03501 18.8716 8.92692C19.3124 7.69475 20.5596 6.98796 21.8708 7.22575C23.087 7.44662 24.0052 8.57729 23.9939 9.84048C23.9817 11.2259 22.8999 12.3509 21.4976 12.4374C20.9948 12.4684 20.8313 12.6366 20.8294 13.1357C20.8275 13.5925 20.8228 14.0492 20.8313 14.506C20.8378 14.8547 21.0587 15.0897 21.3585 15.0878C21.6574 15.0859 21.8736 14.8509 21.882 14.5004C21.8896 14.1733 21.8839 13.8462 21.8839 13.5267L21.8849 13.5276Z"
                      fill="black"
                    />
                    <path
                      d="M9.24072 26.1464V25.1247H24.4977V26.1464H9.24072Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M9.23132 31.4238V30.4115H24.4986V31.4238H9.23132Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M17.4214 22.4987H24.5033V23.5091H17.4214V22.4987Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M17.4138 28.7846V27.7752H24.5023V28.7846H17.4138V28.7846Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M9.23132 23.511V22.509H16.3199V23.511H9.23132Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M16.3208 27.7817V28.7902H9.24072V27.7817H16.3208Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M21.3491 17.2053C22.2307 17.2025 22.9403 17.9055 22.9393 18.7815C22.9393 19.6518 22.2147 20.3737 21.3481 20.3671C20.4938 20.3605 19.7832 19.6528 19.7757 18.7984C19.7673 17.9215 20.4722 17.2091 21.35 17.2053H21.3491ZM21.882 18.7853C21.8848 18.5061 21.6602 18.273 21.3782 18.2627C21.0784 18.2514 20.834 18.4826 20.8321 18.7768C20.8312 19.0531 21.0596 19.2947 21.335 19.3078C21.6197 19.321 21.8782 19.0738 21.882 18.7853V18.7853Z"
                      fill="black"
                    />
                    <path
                      d="M14.4795 8.2474V9.25964H9.23877V8.2474H14.4795Z"
                      fill="black"
                    />
                    <path
                      d="M14.473 11.9091H9.24072V10.8978H14.4721V11.9091H14.473Z"
                      fill="black"
                    />
                    <path
                      d="M9.24072 14.5305V13.5163H14.4683V14.5305H9.24072Z"
                      fill="black"
                    />
                    <path
                      d="M9.23877 17.1781V16.1668H14.4795V17.1781H9.23877Z"
                      fill="black"
                    />
                    <path
                      d="M29.2572 2.1072V3.12132H28.2374V2.1072H29.2572Z"
                      fill="black"
                    />
                    <path
                      d="M29.2582 4.22849V5.23228H28.2356V4.22849H29.2582Z"
                      fill="black"
                    />
                    <path
                      d="M27.1801 34.0234V31.7988H29.4029C28.6773 32.5243 27.9132 33.2894 27.1801 34.0234V34.0234Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M21.8839 13.5276C21.8839 13.8462 21.8905 14.1742 21.882 14.5013C21.8736 14.8509 21.6574 15.0869 21.3585 15.0887C21.0587 15.0906 20.8378 14.8556 20.8313 14.507C20.8228 14.0502 20.8275 13.5934 20.8294 13.1366C20.8313 12.6375 20.9948 12.4693 21.4976 12.4383C22.8999 12.3518 23.9808 11.2268 23.9939 9.84142C24.0052 8.57823 23.087 7.44756 21.8708 7.22669C20.5587 6.9889 19.3124 7.69569 18.8716 8.92786C18.8331 9.03595 18.8002 9.14685 18.7645 9.2587H17.7438C17.7785 7.76712 19.2776 6.34509 21.0155 6.1355C22.7392 5.92778 24.4592 7.1233 24.916 8.84609C25.1989 9.91379 25.0334 10.9129 24.4404 11.8387C23.9676 12.5774 23.6293 12.7945 21.8849 13.5285L21.8839 13.5276Z"
                      fill="#99C83D"
                    />
                    <path
                      d="M21.882 18.7853C21.8792 19.0738 21.6198 19.3219 21.335 19.3078C21.0587 19.2947 20.8303 19.0541 20.8322 18.7768C20.834 18.4826 21.0784 18.2514 21.3782 18.2627C21.6602 18.273 21.8848 18.5052 21.882 18.7853V18.7853Z"
                      fill="#99C83D"
                    />
                  </svg>
                  <span className="counter fig-number">3000</span>
                  <p>
                    <b>Mock Questions</b>
                  </p>
                </div>
              </div>
              <div className="four col-md-3">
                <div className="counter-box">
                  <svg
                    width="37"
                    height="36"
                    viewBox="0 0 37 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M33.2165 33.2294V2.77047C33.0477 2.77047 32.8813 2.77047 32.7148 2.77047C29.6866 2.77047 26.6584 2.77393 23.6302 2.76816C22.5368 2.76584 21.8433 1.7522 22.2883 0.810223C22.5553 0.245035 23.028 -0.00115175 23.6499 4.0498e-06C25.9857 0.00462727 28.3228 0.00231566 30.6587 0.00231566C31.5093 0.00231566 32.36 4.04973e-06 33.2107 0.00231566C34.7768 0.00693888 36.0031 1.2344 36.0031 2.8063C36.0043 12.9277 36.0043 23.0502 36.0031 33.1716C36.0031 34.7712 34.7826 35.9964 33.1887 35.9975C30.0022 35.9998 26.8145 36.0022 23.6279 35.9964C22.5345 35.9941 21.841 34.9804 22.2872 34.0384C22.5553 33.4733 23.028 33.2271 23.6499 33.2282C26.2458 33.2328 28.8417 33.2305 31.4377 33.2305C32.0144 33.2305 32.59 33.2305 33.2153 33.2305L33.2165 33.2294Z"
                      fill="black"
                    />
                    <path
                      d="M24.2313 19.3852H23.762C16.4065 19.3852 9.05094 19.3852 1.69424 19.3852C1.507 19.3852 1.3163 19.3944 1.13368 19.3609C0.436729 19.2326 -0.0521765 18.5853 0.00445794 17.8872C0.0587807 17.2042 0.617034 16.6632 1.31514 16.6205C1.45846 16.6112 1.60409 16.617 1.74741 16.617C9.08908 16.617 16.4296 16.617 23.7713 16.617H24.3203C24.1642 16.4471 24.0671 16.3315 23.9608 16.2252C21.8203 14.0835 19.6797 11.9406 17.5345 9.80238C17.2363 9.50534 17.026 9.18056 17.0191 8.74713C17.0098 8.17385 17.2514 7.73002 17.7588 7.4769C18.2766 7.21916 18.7944 7.26655 19.2613 7.62947C19.3861 7.72656 19.4925 7.8456 19.6057 7.95772C22.6189 10.9617 25.631 13.9656 28.6441 16.9684C29.2579 17.5798 29.2521 18.4258 28.6372 19.0384C25.6032 22.062 22.575 25.0902 19.5318 28.1045C19.2971 28.3369 18.9839 28.5461 18.6707 28.6316C18.0535 28.7992 17.4629 28.4906 17.1751 27.9531C16.8884 27.418 16.989 26.7546 17.4548 26.2865C19.6138 24.1216 21.7763 21.9603 23.9423 19.8024C24.0521 19.6926 24.1954 19.6152 24.3237 19.5227C24.2937 19.4765 24.2625 19.4302 24.2324 19.384L24.2313 19.3852Z"
                      fill="#19294C"
                    />
                  </svg>
                  <span className="counter fig-number">35000</span>
                  <p>
                    <b>Daily Sign-in</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="how-to-use-portal py-40 mb-0 bg-white"
          id="how-to-use-portal"
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>How to use the Portal!</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="howto-video-frame">
                  <iframe
                    className="portal-video"
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/w5R7j5f42Ok"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40 mt-4">
                  <h2>
                    Use Free Mock PTE Test easily from our Language Academy – LA
                    PTE Portal
                  </h2>
                </div>
                <p>
                  <i className="fa fa-check"></i>&nbsp; The experts at Language
                  Academy are fully dedicated to the student's success. Language
                  Academy experts help the student in achieving the target PTE
                  score.
                </p>
                <p>
                  <i className="fa fa-check"></i>&nbsp; Use Free Mock PTE Test
                  easily from our Language Academy – LA PTE Portal.
                </p>
                <p>
                  <i className="fa fa-check"></i>&nbsp; The experts at Language
                  Academy are fully dedicated to the student's success. Language
                  Academy experts help the student in achieving the target PTE
                  score.
                </p>
                <p>
                  <i className="fa fa-check"></i>&nbsp; The PTE mock tests
                  portal of the Language Academy provides the students with the
                  right study material with the questions framed from the right
                  sources in the mock tests and the expert's supervision.
                </p>
                <p>
                  <i className="fa fa-check"></i>&nbsp; PTE mock tests portal
                  gives a real feel to students by increasing their confidence
                  level to appear in the main test. It provides updates to the
                  student on how to access the portal. It provides relevant
                  information on the PTE syllabus and test pattern changes.{" "}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section
          className="la-free-mt-app-testimonial-section py-40 free-mock-test-page"
          id="la-free-mt-app-testimonial-section"
        >
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>
                    Here Is What The Language Academy Students Have To Say
                  </h2>
                  <p>
                    Students who aimed to get a targeted PTE score expressed
                    their thoughts; with the help of the Language Academy's free
                    PTE mock test portal and expert guidance, they achieved
                    their targeted score in all the 4 aspects of PTE exams, i.e.
                    Reading, Writing, Listening and Speaking.
                  </p>
                </div>
              </div>
            </div>
            <div className="row la-free-mt-app-testimonial-mrow">
              <div className="col-lg-12 la-free-mt-app-testimonial-mcol">
                {/*<div className="testimonial-active">*/}
                <div className="testimonial-carousal">
                  <Slider {...settings}>
                    <div className=" la-free-mt-app-testimonial-col4">
                      <div className="single-testimonial la-video-testimonial">
                        <iframe
                          width="290"
                          height="246"
                          src="https://www.youtube.com/embed/m5yHxQTGBUI"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                    <div className=" la-free-mt-app-testimonial-col4">
                      <div className="single-testimonial la-video-testimonial">
                        <iframe
                          width="290"
                          height="246"
                          src="https://www.youtube.com/embed/yQm5J3B-xH4"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                    <div className=" la-free-mt-app-testimonial-col4">
                      <div className="single-testimonial la-video-testimonial">
                        <iframe
                          width="290"
                          height="246"
                          src="https://www.youtube.com/embed/qw1EZlDgGhA"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                    <div className="la-free-mt-app-testimonial-col4">
                      <div className="single-testimonial la-video-testimonial">
                        <iframe
                          width="290"
                          height="246"
                          src="https://www.youtube.com/embed/fxQ7iPQJLCc"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </Slider>
                </div>
                {/*</div>*/}
              </div>
            </div>
          </div>
        </section>
        <section
          className="la-free-mt-app-testimonial-section py-40"
          id="la-free-mt-app-testimonial-section"
        >
          <div className="container">
            <div className="row justify-content-center la-free-mt-app-title-row">
              <div className="col-xl-12 col-lg-12 la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>Commendable Results of our PTE Test Takers!</h2>
                  <p>
                    The student's score on the PTE exam's scorecard speaks the
                    success rate of the Language Academy. Not just 1 time, but
                    many times our students have scored 90 plus. The quality of
                    hard work Language Academy experts provides a student is not
                    luck by chance these many times.
                  </p>
                </div>
              </div>
            </div>
            <div className="row la-free-mt-app-testimonial-mrow">
              <div className="col-lg-12 la-free-mt-app-testimonial-mcol la-scorecard-testimonial">
                {/*<div className="testimonial-active">*/}
                <Slider {...settings}>
                  <div className="la-free-mt-app-testimonial-col4 la-scorecard-testimonial-col">
                    <div className="single-testimonial la-scorecard-testimonial">
                      <img
                        src="/images/pte/pte1.jpg"
                        alt="PTE Scorecard 01"
                      />
                    </div>
                  </div>
                  <div className="la-free-mt-app-testimonial-col4 la-scorecard-testimonial-col">
                    <div className="single-testimonial la-scorecard-testimonial">
                      <img
                        src="/images/pte/pte2.jpg"
                        alt="PTE Scorecard 02"
                      />
                    </div>
                  </div>
                  <div className="la-free-mt-app-testimonial-col4 la-scorecard-testimonial-col">
                    <div className="single-testimonial la-scorecard-testimonial">
                      <img
                        src="/images/pte/pte3.jpg"
                        alt="PTE Scorecard 03"
                      />
                    </div>
                  </div>
                  <div className="la-free-mt-app-testimonial-col4 la-scorecard-testimonial-col">
                    <div className="single-testimonial la-scorecard-testimonial">
                      <img
                        src="/images/pte/pte4.jpg"
                        alt="PTE Scorecard 04"
                      />
                    </div>
                  </div>
                </Slider>
                {/*</div>*/}
              </div>
            </div>
          </div>
        </section>
        <section className="faq py-40" id="faq">
          <div className="container">
            <div className="row">
              <div className="col la-free-mt-app-title-col">
                <div className="section-title la-free-mt-app-title-div text-center pl-40 pr-40">
                  <h2>FAQs</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="col-10 mx-auto">
                  <div className="accordion" id="faqExample">
                    <div className="customCard">
                      <div className="custom-card-header" id="headingOne">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Q. How many PTE mock tests should I attempt?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#faqExample"
                      >
                        <div className="card-body px-0 py-3">
                          <b>Answer:</b> Three full-length PTE mock tests.
                        </div>
                      </div>
                    </div>
                    <div className="customCard">
                      <div className="custom-card-header" id="headingTwo">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Q. What is a scored PTE mock test?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#faqExample"
                      >
                        <div className="card-body px-0 py-3">
                          <b>Answer:</b> Scored PTE mock tests are full-length
                          tests with 4 sections, i.e. listening, reading,
                          writing, and speaking. A student appearing for the
                          mock tests gets the scorecard within 18 hours.
                        </div>
                      </div>
                    </div>
                    <div className="customCard">
                      <div className="custom-card-header" id="headingThree">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-link collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Q. What is the duration of a full-length PTE mock
                            test?
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-parent="#faqExample"
                      >
                        <div className="card-body px-0 py-3">
                          <b>Answer:</b> Around 2 hours. Students can attempt
                          the test in one go or by taking short breaks.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default FreeMockTest